// extracted by mini-css-extract-plugin
export default {"solidBtn":"solidBtns_solidBtn__3b+op"};